<template>
  <div class="releases-timeline">
    <div v-if="loading" class="text-center">
      <circles-loader></circles-loader>
    </div>
    <div v-else class="pa-2">
      <v-timeline :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item
          v-for="(i, index) in releases"
          :key="i._id"
          color="plusIndigoLighten1"
          fill-dot
        >
          <template v-slot:icon>
            <v-icon color="white" small>mdi-cube-outline</v-icon>
          </template>
          <template v-slot:opposite>
            <span class="supporting-text plusTextSecondary--text">{{
              $d(new Date(i.time), 'short_year', $i18n.locale)
            }}</span>
          </template>
          <v-expansion-panels flat>
            <v-expansion-panel class="release-panel">
              <v-expansion-panel-header
                :class="
                  isOdd(index) && !isSmallerDisplay()
                    ? 'text-right'
                    : 'text-left'
                "
                @click="acknowledgeRelease(i)"
              >
                <div class="plusTextPrimary--text font-weight-medium">
                  <v-icon class="mr-1" v-if="i.isNew" color="plusIndigoLighten1"
                    >mdi-exclamation</v-icon
                  >
                  {{ i.version }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ImageDisplay
                  width="100%"
                  v-if="i.image"
                  :src="i.image"
                ></ImageDisplay>
                <v-list-item-content
                  class="plusTextPrimary--text"
                  v-html="i.contents"
                ></v-list-item-content>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="likeRelease(i)"
                    :color="i.liked ? 'plusIndigoLighten1' : 'plusTextSecondary'"
                  >
                    <v-icon>mdi-thumb-up</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-timeline-item>
      </v-timeline>
      <div v-if="hasMore" class="text-center pt-2 pb-4">
        <v-btn outlined small elevation="0" color="primary" :loading="loadingMore" @click="loadMore">
          {{ $t('message.view_more') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/Api';
import CirclesLoader from '@/components/displays/CirclesLoader.vue';

export default {
  data() {
    return {
      loading: true,
      loadingMore: false,
      releases: [],
      page: 1,
      pageSize: 12,
      hasMore: false,
    };
  },
  components: { CirclesLoader },
  created() {
    if (this.$store.state.managedAcademy) {
      Api()
        .get('releases/project/bjjlink-admin?page=' + this.page + '&limit=' + this.pageSize)
        .then((response) => {
          this.loading = false;
          this.releases = response.data.releases;
          this.hasMore = response.data.releases.length === this.pageSize;
        });
    }
  },
  methods: {
    loadMore() {
      this.loadingMore = true;
      const nextPage = this.page + 1;
      Api()
        .get('releases/project/bjjlink-admin?page=' + nextPage + '&limit=' + this.pageSize)
        .then((response) => {
          this.loadingMore = false;
          this.page = nextPage;
          this.releases = this.releases.concat(response.data.releases);
          this.hasMore = response.data.releases.length === this.pageSize;
        })
        .catch(() => {
          this.loadingMore = false;
        });
    },
    likeRelease(item) {
      const releaseId = item._id;
      Api()
        .patch('releases/like/release/' + releaseId)
        .then((response) => {
          if (response) {
            const liked = response.data.liked;
            item.liked = liked;
          }
        });
    },
    isOdd(num) {
      return num % 2;
    },
    isNew(release) {
      if (
        release.seenBy &&
        release.seenBy.indexOf(this.$store.state.user._id) >= 0
      )
        return false;
      return true;
    },
    acknowledgeRelease(r) {
      if (r.isNew) {
        Api()
          .patch('releases/acknowledge/releases', { releases: [r._id] })
          .then((response) => {
            if (response) {
              r.isNew = false;
              var currentCount = this.$store.state.releasesCount;
              currentCount--;
              this.$store.dispatch('setReleasesCount', currentCount);
            }
          });
      }
    },
  },
};
</script>

<style>
.releases-timeline .v-timeline::before {
  background: var(--v-plusBorder-base) !important;
}

.releases-timeline .release-panel {
  background-color: var(--v-plusSurface-base) !important;
  border: 1px solid var(--v-plusBorder-base);
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.12) !important;
}

.theme--dark .releases-timeline .release-panel {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.releases-timeline .release-panel::before {
  box-shadow: none !important;
}

.releases-timeline .v-expansion-panel-header {
  color: var(--v-plusTextPrimary-base) !important;
}

.releases-timeline .v-expansion-panel-header__icon .v-icon {
  color: var(--v-plusTextSecondary-base) !important;
}

.releases-timeline .v-expansion-panel-content__wrap {
  color: var(--v-plusTextPrimary-base) !important;
}

.releases-timeline .supporting-text {
  font-size: 0.85rem;
}
</style>
